<template>
    <div>
        <b-row class="toolbar-ptc">
            <b-col>
                <router-link :to="{ name: 'store_menu_list', params: { search: this.$route.params.search } }" class="btn btn-ptc1" tag="button">返回</router-link>
            </b-col>
            <b-col class="text-center title">門市服務 / 餐點DM上傳 / 新增</b-col>
            <b-col>
                <div class="text-right">
                    <button type="button" class="btn btn-save" @click="save">儲存</button>
                    <button type="button" class="btn btn-clear" @click="clear">清除</button>
                </div>
            </b-col>
        </b-row>
        <div id="func-content">
            <b-card class="bg-default-card">
                <div class="row">
                    <div class="col-lg-12">
                        <form class="form-horizontal form-validation">

                            <div class="col-lg-12">
                              <div class="form-group">
                                <label class="control-label">品牌：</label>
                                <div>
                                  <select
                                    name="queryBrandsCode"
                                    class="form-control"
                                    v-model="brandCode"
                                  >
                                  <option
                                    v-for="x in selectListBrands"
                                    v-bind:value="x.Code"
                                    :key="x.Code"
                                  >{{x.Text}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group">
                                    <label class="control-label">餐點類別</label>
                                    <input type="text" class="form-control" v-model="title" maxlength="8" placeholder="請輸入DM餐點類別">
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="form-group">
                                    <label class="control-label">圖片上傳</label>
                                    <div class="form-group">
                                      <input type="file" class="upload_input" id="pic" ref="inputer" multiple @change="handleFileChange">
                                      <label class="upload_block" for="pic">
                                      <span class="upload_icon">➕</span>
                                      <img class="upload_img" v-if="img_url != undefined" :src="img_url">
                                      </label>
                                    </div>
                                    <span class="control-label text-red" style="color: #ff0000">**寬度最小750 高度建議超過1334**</span>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label class="control-label">開始日期</label>
                                            <input type="date" class="form-control" :min="today" v-model="sdate" max="9999-12-31" @input="changeDate($event, 1)" v-on:keydown="keydownDate($event, 1)">
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label class="control-label">結束日期</label>
                                            <input type="date" class="form-control" :min="today" v-model="edate"  max="9999-12-31" @input="changeDate($event, 2)" v-on:keydown="keydownDate($event, 2)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </b-card>

            <!-- Double Check Modal -->
            <b-modal ref="mdCheck" hide-footer title="餐點DM上傳">
            <b-container fluid>
                <form>
                <div class="row mb-3">
                    <label class="control-label">確定新增此則DM ?</label>
                </div>
                <div class="float-right">
                    <b-btn variant="primary" @click="confirm">確定</b-btn>
                    <b-btn variant="secondary" @click="cancel">取消</b-btn>
                </div>
                </form>
            </b-container>
            </b-modal>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import VueForm from 'vue-form'
import miniToastr from 'mini-toastr'
import options from '../../../validations/validations.js'
import axios from 'axios'
import {API_URL, fileUploadMaxSize} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
Vue.use(VueForm, options)
export default {
  data () {
    return {
      title: '',
      sdate: this.getTomorrow(),
      edate: '9999-12-31',
      url: '',
      img_url: undefined,
      today: '',
      sdateInvalid: false,
      edateInvalid: false,
      ddl_type: 0,
      ddl_camp: 0,
      items: [],
      brandCode: 'MWD',
      selectListBrands: [], // 品牌下拉選單
    }
  },
  props: {
    value: {
      default: undefined
    }
  },
  methods: {
    changeDate (e, type) {
      // 日期變更事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    keydownDate (e, type) {
      // 日期輸入事件
      if (type === 1) {
        this.sdateInvalid = e.target.validity.badInput
      } else {
        this.edateInvalid = e.target.validity.badInput
      }
    },
    getTomorrow () {
      var date = new Date()
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate() + 1

      if (mon < 10) {
        mon = '0' + mon
      }

      var fullDate = year + '-' + mon + '-' + day

      return fullDate
    },
    handleFileChange (e) {
      let inputDOM = this.$refs.inputer
      this.file = inputDOM.files[0]
      this.$emit('input', this.file)
      this.fileName = this.file.name
      if (!this.imgPreview(this.file)) {
        this.$refs.inputer.value = ''
        this.img_url = undefined
      }
    },
    imgPreview (file) {
      var rtn = false
      let self = this
      if (!file || !window.FileReader) return

      if (/^image/.test(file.type)) {
        if (file.size > fileUploadMaxSize) {
          miniToastr.error('圖檔大小不可超過 5MB')
        } else {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onloadend = function () {
            self.img_url = this.result
          }
          rtn = true
        }
      } else {
        miniToastr.error('請選擇正確圖檔')
      }
      return rtn
    },
    ddlCampChange () {
      this.ddl_camp = 0
    },
    save () {
      if (this.title.trim() === '') {
        miniToastr.error('請輸入標題文字')
        return
      }
      if (this.img_url === undefined || this.img_url === '') {
        miniToastr.error('請選擇上傳圖片')
        return
      }
      if (this.sdate < this.today) {
        miniToastr.error('開始日期不得小於系統時間')
        return
      }
      if (this.sdateInvalid || this.edateInvalid) {
        miniToastr.error('日期格式輸入錯誤，請重新輸入')
        return
      }
      if (this.sdate > this.edate) {
        miniToastr.error('結束日期不得小於開始日期')
        return
      }
      this.$refs.mdCheck.show()
    },
    clear () {
      this.title = ''
      this.img_url = undefined
      this.sdateInvalid = false
      this.edateInvalid = false
      this.sdate = this.getTomorrow()
      this.edate = '9999-12-31'
    },
    cancel () {
      this.$refs.mdCheck.hide()
    },
    confirm () {
      this.$refs.mdCheck.hide()
      let formData = new FormData()
      formData.append('image', this.file)
      formData.append('title', this.title)
      formData.append('sdate', this.sdate)
      formData.append('edate', this.edate)
      formData.append('brandCode', this.brandCode)
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/create/leaflet/v1',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('餐點DM上傳成功')
            this.$router.push({ name: 'store_menu_list' })
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else if (response.data.result === '1113') {
            miniToastr.error(response.data.message)
          } else {
            miniToastr.error(response.data.message, '新增菜單失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
          miniToastr.error('餐點DM上傳失敗')
        })
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v2", {
          all: false,
          order: false,
          menupage: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F09') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
      return
    }
    var search = this.$route.params.search
    if (search !== undefined) {
      this.search = search
    }

    var date = new Date()
    var year = date.getFullYear()
    var mon = date.getMonth() + 1
    var day = date.getDate()

    if (mon < 10) {
      mon = '0' + mon
    }
    if (day < 10) {
      day = '0' + day
    }
    this.today = year + '-' + mon + '-' + day

    this.querySelectListBrands();
  }
}
</script>
<style scoped>
    .upload_block {
        position: relative;
        width: 260px;
        height: 180px;
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
        background: #f1f1f1;
        border: 3px dashed #d6d4d4;
    }
    .upload_input {
        display: none;
    }
    .upload_img {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 2;
    }
    .upload_icon {
        font-weight: bold;
        font-size: 200%;
        position: absolute;
        z-index:1;
        left: 0;
        width: 100%;
        top: 35%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/store/menu/Add.vue